import {fromEventSource} from 'most-w3msg';
import {fromPromise} from 'most';
import queryString from 'qs';
import moment from 'moment';
import request from 'superagent';
import {localeFull, isoCurrency, market, environment, isAirtickets} from 'helpers/stableValues';
import {domain} from 'ferries/helpers/common';
import * as R from 'ramda/src/index';

const baseUrl = (['production', 'staging'].includes(environment))
  ? 'https://mule.airtickets.com/api/v1'
  : 'http://localhost:12345/api/v1';

export const getSearchResults = ({
  dep, arr, obDate, ibDate, isRoundtrip, passengersAdult, passengersChild,
  passengersInfant, class: cabinClass = '', airlineCode = '', directFlightsOnly, extendedDates, es
}) => {
  const params = {
    routes: [
      {
        departure: dep,
        arrival: arr,
        datetime: moment(obDate).utc().subtract(obDate.getTimezoneOffset(), 'minutes').toISOString().split('.')[0]
      }
    ],
    passengers: [
      {
        type: 'adults',
        count: Number(passengersAdult)
      },
      {
        type: 'children',
        count: Number(passengersChild)
      },
      {
        type: 'infants',
        count: Number(passengersInfant)
      }
    ],
    cabinClass,
    carrier: airlineCode,
    directRoutes: directFlightsOnly === '1',
    flexibleDates: extendedDates === '1',
    locale: localeFull,
    currency: isoCurrency(),
    market: isAirtickets && market === 'tp' ? 'us' : market,
    es,
    cache: true
  };
  if (isRoundtrip) {
    params.routes.push({
      departure: arr,
      arrival: dep,
      datetime: moment(ibDate).utc().subtract(ibDate.getTimezoneOffset(), 'minutes').toISOString().split('.')[0]
    });
  }

  if (window.EventSource) {
    const source = new EventSource(`${baseUrl}/search-async?${queryString.stringify(params, {allowDots: true})}`);

    return fromEventSource(source, source.close.bind(source))
      .map((res) => {
        const parsedData = JSON.parse(res.data);
        return R.map((data) => ({
          ...data,
          resourceId: parsedData.resourceId
        }), parsedData.data);
      });
  }

  return fromPromise(
    request
      .get(`${baseUrl}/search-sync?${queryString.stringify(params, {allowDots: true})}`)
  ).map(({body}) => R.map((data) => ({
    ...data,
    resourceId: body.resourceId
  }), body.data));
};

export const getRedirectUri = ({resourceId, id, provider}) => {
  return request
    .get(`${baseUrl}/redirect`)
    .query({resourceId, id, provider})
    .then(({body}) => body);
};

export const getFerryRedirectUri = ({tp24Id, resourceId, segmentId}) => {
  return request
    .get(`${domain}/api/v1/ferries/redirect`).set('x-override-header', 'ferryscanner-web')
    .query({tp24Id, resourceId, 'segments[0][id]': segmentId})
    .then(({body}) => body);
};
